import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface UploadPestUserSignatureParams {
  signatureData: string;
  visitReportId: number;
}

export const uploadPestUserSignature = async ({ signatureData, visitReportId }: UploadPestUserSignatureParams) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const formData = new FormData();
  formData.append('user_signature', dataURItoBlob(signatureData), `PestUserSignature_${visitReportId}.png`);

  const data = await axiosInterceptor.patch(
    `${process.env.REACT_APP_BASE_DJANGO_URL}/api/user/update-signature/`,
    formData,
    {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data.data as any;
};

const dataURItoBlob = (dataURI: string) => {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeString });
};
